import React, { useState } from "react"

import {Compass} from "../../atoms/compass/index"

import {
  CoverPageContainer,
  CoverPageContent,
  CoverPageListContainer,
  CoverPageSingleList,
  CoverLogoContainer,
  CoverPageWrapper,
} from './styles';

import { themeColor } from "../../layout/global-style";
import useEventListener from '../../../utils/useEventListener';
import { FormattedMessage, useIntl } from "gatsby-plugin-intl";
import { timeout } from "../../../utils/useTimeout";
import Title from '../../atoms/title/index'
import Logo from '../../atoms/logo/index'
import { Subtitle } from '../../atoms/subtitle/index'
import Button from '../../atoms/button/index'

const pageMobileHeight = () => {
  return typeof window !== `undefined` && window.innerWidth < 1024 ? window.innerHeight + `px` : '100vh';
}

const CoverPage = React.memo(({ disabled, onStart }) => {
  const [pageHeight, setPageHeight] = useState(pageMobileHeight());
  useEventListener('resize', () => setPageHeight(pageMobileHeight()), typeof window !== `undefined` ? window : null);
  const intl = useIntl();

  const onClick = async (e) => {
    e.stopPropagation();
    await timeout(300);
    onStart && onStart();
  }

  return (
    <CoverPageContainer height={pageHeight}>
      <Compass />
      <CoverPageWrapper>
        <CoverPageContent>
          <CoverLogoContainer>
            <Logo />
          </CoverLogoContainer>
          <Title color={themeColor.black} messageid={"app.title"} />
          <Subtitle color={themeColor.black}><FormattedMessage id="app.subtitle" /></Subtitle>
          <CoverPageListContainer>
            <CoverPageSingleList>
              <Button red onClick={onClick}>
                {/*<CDPA color={themeColor.red} /> */}
                {`${intl.formatMessage({ id: `sign.in.with.title` })} ${intl.formatMessage({ id: `sign.in.with.cdpr` })}`}
              </Button>
            </CoverPageSingleList>
          </CoverPageListContainer>
        </CoverPageContent>
      </CoverPageWrapper>
    </CoverPageContainer>
  )
})

export default CoverPage;
